"use strict";
/**
 * @param {string} nextLocale - The local in next Next.js router format (e.g. en-ca, en-us, fr-ca)
 * @returns {string} - Returns an i18n locale (e.g. en-ca, en-us, fr-ca) in the underscored format (e.g. en_US, fr_CA, en_CA)
 */ export var convertToUnderscored = function(nextLocale) {
    checkNextLocaleFormat(nextLocale, "convertToUnderscored");
    var splitArr = nextLocale.split("-");
    return splitArr[0] + "_" + splitArr[1].toUpperCase();
};
/**
 *
 * @param {string} nextLocale - The local in next Next.js router format (e.g. en-ca, en-us, fr-ca)
 * @returns {string} - Returns an i18n locale (e.g. en-ca, en-us, fr-ca) in the dashed format (e.g. en-US, fr-CA, en-CA)
 */ export var convertToDashed = function(nextLocale) {
    checkNextLocaleFormat(nextLocale, "convertToDashed");
    var splitArr = nextLocale.split("-");
    return splitArr[0] + "-" + splitArr[1].toUpperCase();
};
/**
 *
 * @param {string} nextLocale - The local in next Next.js router format (e.g. en-ca, en-us, fr-ca)
 * @returns {string} - Returns an i18n locale (e.g. en-ca, en-us, fr-ca) in the country code format (e.g. CA, US, CA)
 */ export var convertToCountryCode = function(nextLocale) {
    checkNextLocaleFormat(nextLocale, "convertToCountryCode");
    return nextLocale.split("-")[1].toUpperCase();
};
/**
 *
 * @param {string} nextLocale - The local in next Next.js router format (e.g. en-ca, en-us, fr-ca)
 * @returns {string} - Returns an i18n locale (e.g. en-ca, en-us, fr-ca) in the language format (e.g. en, fr)
 */ export var convertToLanguage = function(nextLocale) {
    checkNextLocaleFormat(nextLocale, "convertToLanguage");
    return nextLocale.split("-")[0].toLowerCase();
};
/**
 * @deprecated
 * @param {string} underscoredLocale - The locale in the underscored format (e.g. en_US, fr_CA, en_CA)
 * @returns {string} - Returns an i18n locale (e.g. en-ca, en-us, fr-ca) in the i18n format (e.g. en-ca, en-us, fr-ca)
 */ export var convertUnderscoredToI18n = function(underscoredLocale) {
    checkUnderscoredFormat(underscoredLocale, "convertUnderscoredToI18n");
    return underscoredLocale.replace("_", "-").toLowerCase();
};
var checkNextLocaleFormat = function(locale, functionName) {
    var splitArr = locale.split("-");
    if (!Array.isArray(splitArr) || splitArr.length < 2) {
        throwInvalidLocaleError(locale, functionName);
    }
};
var checkUnderscoredFormat = function(locale, functionName) {
    var splitArr = locale.split("_");
    if (!Array.isArray(splitArr) || splitArr.length < 2) {
        throwInvalidLocaleError(locale, functionName);
    }
};
var throwInvalidLocaleError = function(nextLocale, functionName) {
    throw new Error(functionName + ": The locale value received '" + nextLocale + "' is not in the expected format.");
};
/**
 * Returns location title tag with Canada appended if Canadian locale
 * @example
 * athletic apparel + technical clothing | lululemon Canada
 * @param {string} nextLocale A string of the locale from Next router, e.x. en-ca
 * @param {string} title A string title of the page
 * @returns string for title tag content
 */ export var getRegionalizedTitleTag = function(nextLocale, title) {
    var _nextLocale;
    return [
        "en-ca",
        "fr-ca"
    ].includes((_nextLocale = nextLocale) == null ? void 0 : _nextLocale.toLowerCase()) ? "" + title + " Canada" : title;
};
/**
 *
 * @param {string} nextLocale - The locale from Next router, e.x. en-ca
 * @returns {boolean} - Returns whether or not the locale is used as a regionalized subpath (e.g. /en-ca/)
 */ export var isRegionalizedSubPath = function(nextLocale, defaultLocale) {
    if (defaultLocale === void 0) defaultLocale = "en-us";
    return !!nextLocale && nextLocale !== defaultLocale;
};
/**
 * Regionalizes relative URL provided the required parameters
 *
 * @param {locale} - The locale of a current page otherwise nextLocale.
 * @returns {string} - The path of a given page to regionalize.
 */ export var getRegionalizedRelativeUrl = function(locale, path) {
    if (locale === void 0) locale = "en-us";
    if (path === void 0) path = "";
    return locale !== "en-us" && path && !path.includes(locale) ? "/" + locale + path : path;
};
/**
 * Determines if a given URL is relative or absolute.
 * @param {string} path - The URL to check.
 * @param {string} locale - The locale string to be converted to
 * @returns {string} - Returns "absolute" if the URL is absolute, "relative" if the URL is relative.
 */ export var getRegionalizedAbsoluteUrl = function(path, locale) {
    try {
        // If the path is already regionalized, remove the regionalized subpath
        var regionalizedUrl = new URL(path);
        // If the path is not regionalized, add the regionalized subpath if the targeted locale requires a regionalized subpath
        // Example: If the targeted locale is 'en-ca', add the regionalized subpath '/en-ca' to the path
        regionalizedUrl.pathname = isRegionalizedSubPath(locale) ? "/" + locale + regionalizedUrl.pathname : regionalizedUrl.pathname;
        return regionalizedUrl.href;
    } catch (error) {}
    return path;
};
